// Generate consistent color from username hash
function avatarColor(name: string): string {
  const colors = ['#00d158','#3b82f6','#8b5cf6','#f59e0b','#ef4444','#06b6d4','#ec4899','#84cc16']
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return colors[Math.abs(hash) % colors.length]
}

export default function Avatar({ name, size = 44, className = '' }: { name: string; size?: number; className?: string }) {
  const bg = avatarColor(name)
  return (
    <div className={className || 'c-avatar'} style={{ width: size, height: size, background: bg, fontSize: size * 0.38 }}>
      {name[0].toUpperCase()}
    </div>
  )
}
